import React from "react";
import { useStyles } from "./style";
import successTick from "../../../assets/images/successTick.png";

const SuccessMessage = ({ showMessage, message, title = "Success!" }) => {
  const classes = useStyles();
  return (
    <div className={classes.successContainer}>
      <img
        className={classes.successImg}
        src={successTick}
        alt={"Success Img"}
      />
      <p className={classes.successTitle}>{title}</p>
      {showMessage && <p className={classes.message}>{message}</p>}
    </div>
  );
};

export default SuccessMessage;
